// src/storage/index.js
import LocalStorageService from "./LocalStorageService"

// Punto único de acceso al storage
export const storage = new LocalStorageService()